import { Typography } from '@cobliteam/ui/components';
import { InputMask } from '@cobliteam/ui/form';
import type React from 'react';
import type { Boundaries } from '../types';

interface TimeInputsProps {
  startTime: string;
  endTime: string;
  boundaries: Boundaries;
  onTimeInputChange: (value: string, field: 'startTime' | 'endTime') => void;
  onTimeBlur: (event: React.FocusEvent<HTMLInputElement>, field: 'startTime' | 'endTime', minValue: string, maxValue: string) => void;
}

const TimeInputs: React.FC<TimeInputsProps> = ({ startTime, endTime, boundaries, onTimeInputChange, onTimeBlur }) => {
  return (
    <div className='flex items-center gap-3'>
      <div className='flex items-center gap-1'>
        <Typography variant='text-sm-medium' color='default'>
          Início:
        </Typography>
        <InputMask
          size='sm'
          value={startTime}
          onChange={(e) => onTimeInputChange(e.target.value, 'startTime')}
          onBlur={(e) => onTimeBlur(e, 'startTime', boundaries.min, endTime)}
          mask='__:__'
          replacement={{ _: /\d/ }}
          className='w-20'
          placeholder='HH:MM'
          aria-label='Início do filtro de tempo'
        />
      </div>
      <div className='flex items-center gap-1'>
        <Typography variant='text-sm-medium' color='default'>
          Fim:
        </Typography>
        <InputMask
          size='sm'
          value={endTime}
          onChange={(e) => onTimeInputChange(e.target.value, 'endTime')}
          onBlur={(e) => onTimeBlur(e, 'endTime', startTime, boundaries.max)}
          mask='__:__'
          replacement={{ _: /\d/ }}
          className='w-20'
          placeholder='HH:MM'
          aria-label='Fim do filtro de tempo'
        />
      </div>
    </div>
  );
};

export default TimeInputs;
